<template>
  <div class="member_card_wrap">
    <div class="card_top_box">
      <div class="pic">
        <img v-lazy="headInfo.userHeadUrl" class="user_pic" />
        <img src="../imgs/m_icon1.png" class="icon_pic" />
      </div>
      <div class="title_box">
        <h5>{{ membership.brandName }}</h5>
        <p v-if="membership.cardNo">No.{{ membership.cardNo }}</p>
      </div>
      <div v-if="isNoBuyStatus" class="status">{{ $t('FoodC_update_ErLg_Lrtz' /* 过期*/) }}</div>
    </div>
    <div class="card_info_box">
      <!-- 累计节省金额 -->
      <template v-if="totalSavedText && totalSavedAmount">
        <div class="price_box" @click="handleDetail">
          <div class="msg">{{ totalSavedText }}</div>
          <div class="price" :class="priceClass">
            {{ totalSavedAmount }}
            <div v-if="isCanJump" class="price_icon">
              <img src="../imgs/icon_arrows.png" alt="" />
            </div>
          </div>
        </div>
      </template>
      <!-- 提示文案 -->
      <template v-else>
        <div class="new_msg">
          <p class="hyphenate-text">
            {{ $t('FoodC_update_PQxd_TDOz', { brand: membership.brandName }) }}
          </p>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import mixin from '@/page/member/mixins.js'

export default {
  name: 'MemberCard',
  mixins: [mixin],
  props: {
    membership: {
      type: Object,
      default: () => {},
    },
    headInfo: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    // return string 提示文案
    totalSavedText() {
      return this.membership?.alreadySavedDisplay?.text || ''
    },
    // return string 金额文案
    totalSavedAmount() {
      return this.membership?.alreadySavedDisplay?.amount || ''
    },
    // 已节省金额大于0
    alreadySavedAmount() {
      return this.membership?.alreadySavedDisplay?.alreadySavedAmount > 0
    },
    // 是否可跳转
    isCanJump() {
      return this.isMemberOrderDetail && this.alreadySavedAmount
    },
    // 基于字符长度，设置字体大小
    priceClass() {
      const num = this.totalSavedAmount?.length || 0
      if (num > 9 && num <= 12) {
        return 'f60'
      } else if (num > 12) {
        return 'f50'
      }
      return ''
    },
  },
  methods: {
    handleDetail() {
      // 命中会员订单详情页 且 已节省金额大于0
      if (this.isCanJump) {
        this.$router?.push({
          path: '/member/bill',
          query: {
            nativeWebUIType: 1,
          },
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/mixin.scss';

.member_card_wrap {
  margin-left: 20px;
  margin-bottom: 28px;
  width: 710px;
  height: 376px;
  background-image: linear-gradient(90deg, #ffffff 19%, #fffcfb 100%);
  border-radius: 40px;
  font-size: 28px;
}
.card_top_box {
  position: relative;
  padding-top: 48px;
  padding-left: 32px;
  display: flex;
  .pic {
    width: 120px;
    height: 120px;
    position: relative;
    .user_pic {
      width: 120px;
      height: 120px;
      border-radius: 50%;
    }
    .icon_pic {
      position: absolute;
      width: 48px;
      height: 48px;
      bottom: 0px;
      right: -13px;
    }
  }
  .title_box {
    padding-left: 28px;
    width: 380px;
    h5 {
      padding-top: 8px;
      height: 72px;
      font-family: DiDiSans-Pro-ExtraBoldTest;
      font-size: 72px;
      color: #0b0b0d;
      letter-spacing: 0;
      line-height: 72px;
      font-weight: normal;
    }
    p {
      padding-top: 1px;
      height: 36px;
      font-family: DiDiSans-Pro-Medium;
      font-size: 28px;
      color: #0b0b0d;
      line-height: 36px;
      font-weight: 500;
    }
  }
  .status {
    position: absolute;
    right: 0;
    top: 63px;
    padding: 16px 16px 16px 24px;
    background: #89898c;
    border-radius: 16px 0 0 16px;
    font-family: DiDiSans-Pro-Bold;
    font-size: 24px;
    color: #ffffff;
    height: 24px;
    line-height: 24px;
  }
}
.card_info_box {
  padding-top: 76px;
  padding-left: 32px;
  padding-right: 32px;
  .new_msg {
    p {
      @include ellipsis(3);
      font-family: DiDiSans-Pro-Medium;
      font-size: 28px;
      color: #89898c;
      line-height: 36px;
      font-weight: 500;
    }
  }
  .price_box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .msg {
      margin-right: 20px;
      width: 145px;
      height: 72px;
      // background-color: yellow;
      font-family: DiDiSans-Pro-Medium;
      font-size: 28px;
      color: #89898c;
      line-height: 36px;
      font-weight: 500;
    }
    .price {
      // background-color: yellow;
      width: 490px;
      font-family: DiDiSans-Pro-ExtraBold;
      font-size: 68px;
      color: #0b0b0d;
      // text-align: right;
      line-height: 96px;
      font-weight: normal;
      // @include ellipsis(1);
      display: flex;
      justify-content: flex-end;
      &.f60 {
        font-size: 60px;
      }
      &.f50 {
        font-size: 50px;
      }
      .price_icon {
        width: 48px;
        height: 48px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>
